module.exports = __webpack_public_path__ + "static/pho2-4b88099f0cb8011b34335709162a41d2.jpg";